import { MtTask } from "server/models"
import { TableNestedIds } from "client/components"
import { TaskProjectGroupedIds } from "./types"

export const GroupTasksByParent = (tasks: MtTask[]) => {
    const groupedByParent: { [parentTaskId: number]: MtTask[] } = { 0: [] }
    tasks.forEach((task) => {
        if (task.taskId === null) groupedByParent[0].push(task)
        else {
            if (!groupedByParent[task.taskId]) groupedByParent[task.taskId] = []
            groupedByParent[task.taskId].push(task)
        }
    })
    return groupedByParent
}

export const GetTaskNested = (parentId: number, groupedByParent: { [parentTaskId: number]: MtTask[] }) => {
    const nestedIds: TableNestedIds[] = []
    const childTasks = groupedByParent[parentId]
    if (childTasks) {
        childTasks.forEach((task) => {
            const nestedId: TableNestedIds = {
                id: task.id,
                nestedIds: GetTaskNested(task.id, groupedByParent),
            }
            nestedIds.push(nestedId)
        })

        // eslint-disable-next-line no-param-reassign
        delete groupedByParent[parentId] // remove used rows
    }
    return nestedIds
}

export const PrepareTaskNestedIds = (tasks: MtTask[], groupByProject: boolean) => {
    const groupedByParent = GroupTasksByParent(tasks)
    const groupedByProject: TaskProjectGroupedIds = {}

    Object.keys(groupedByParent).forEach((key) => {
        const parentTaskId = key as unknown as number
        // continue if row was added to nested level
        if (!groupedByParent[parentTaskId]) return

        // all filtered tasks that were not added to nested levels will be added to the top level
        groupedByParent[parentTaskId].forEach((task) => {
            const projectId = task.projectId === null ? 0 : task.projectId
            if (!groupedByProject[projectId]) {
                groupedByProject[projectId] = {
                    // don't show group on project level
                    groupId: groupByProject && task.project ? task.project.id : null,
                    groupData: groupByProject && task.project ? task.project.name : null,
                    level: 2,
                    nestedIds: [],
                    nestedGroupedIds: [],
                }
            }

            const nestedId: TableNestedIds = {
                id: task.id,
                nestedIds: GetTaskNested(task.id, groupedByParent),
            }

            const nestedIdsCopy = groupedByProject[projectId].nestedIds.slice()
            nestedIdsCopy.push(nestedId)
            groupedByProject[projectId].nestedIds = nestedIdsCopy
        })
    })

    return groupedByProject
}
